/* eslint-disable max-len */
import React from 'react';

export function WorkspaceIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" data-iconid="456349" data-svgname="Chart pie graph">
      <defs />
      <path d="M22.5,11.05H13V1.5A9.54,9.54,0,0,1,22.5,11.05Z" />
      <path d="M11.05,13.91h7.63a8.59,8.59,0,1,1-8.59-8.59v8.59L16.16,20" />
    </svg>
  );
}
